<template>
    <div class="wrapper">
        <Header />
        <div v-if="$store.state.isUpdateProfile && $store.state.isLoggedIn" class="wrapper__warning">
            <img class="wrapper__warning__image" src="@/assets/images/toast/error.png" />
            <p class="wrapper__warning__text" v-html='getTranslatedText(`You account is missing a few details, please update it`)' />
        </div>
        <div class="wrapper__content">
            <router-view />
        </div>
        <Footer v-if="this.$router.history.current.meta.isShowFooter" />
    </div>
</template>
<script>
import Header from "@/components/mobile/header/index.vue";
import Footer from "@/components/mobile/footer/index.vue";
import LanguageMixin from "@/mixins/language/language-mixin";

export default {
    mixins: [LanguageMixin],
    components: {
        Header,
        Footer,
    },
};
</script>
